import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '@core/services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Resolve AuthService lazily to avoid DI cycle:
    // TokenInterceptor -> AuthService -> HttpClient -> TokenInterceptor
    const authService = this.injector.get(AuthService);
    const userToken = authService.getAccessToken();
    const authReq = userToken
      ? req.clone({
          withCredentials: true,
          setHeaders: {
            authorization: 'Bearer ' + userToken,
          },
        })
      : req.clone({ withCredentials: true });

    return next.handle(authReq);
  }
}
